import { useState } from 'react';
import Button from 'react-bootstrap/Button';
import InputGroup from 'react-bootstrap/InputGroup';
import FormControl from 'react-bootstrap/FormControl';
import Form from 'react-bootstrap/Form';
// import Spinner from 'react-bootstrap/Spinner';
import { useUserContext } from '../../../hooks/userHook';
import { cleanSchedules } from '../../../data/api';
import { CustomResponse } from '../../../models';

export default function Fix() {
  const { user } = useUserContext();
  const [scheduleCleanDate, setScheduleCleanDate] = useState<Date>(new Date());
  const [status, setStatus] = useState<CustomResponse>(null);
  // const loading = false;


  return (
    <div id="create-schedule" className="row mb-3">
      <div className="col-md-6 col-lg-4 col-sm-12 mb-4">
        <h1>Available Fixes <span className='text-small'>- !! Use Caution !!</span></h1>

        <Form.Label htmlFor="schedule-clean-date" className="mt-4">Clean Unbooked Schedules</Form.Label>
        <InputGroup className="mb-3">
          <FormControl
            id="schedule-clean-date"
            type="date"
            onChange={(e) => setScheduleCleanDate(new Date(e.target.value))}
            max={new Date().toISOString().split('T')[0]}
            value={scheduleCleanDate.toISOString().split('T')[0]}
            placeholder="Clean Date"
            aria-label="Clean Date"
            aria-describedby="Clean Unbooked Schedules"
          />
          <Button
            type='button'
            size="sm"
            onClick={async () => setStatus(await cleanSchedules(scheduleCleanDate, user?.token))}
          >
            Clean Non-Booked
          </Button>
        </InputGroup>

        {status && (
          <div className={`alert alert-${status.success ? 'success' : 'danger'} mt-3`} role="alert">
            {status.message}
          </div>
        )}
      </div>
    </div>
  );
}
